function getCartCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

function handleUnauthorizedAccess(response) {
    // Si c'est un objet, on le convertit en string pour la vérification
    const text = typeof response === 'object' ? JSON.stringify(response) : response;
    
    if (text.includes('Unauthorized access')) {
        alert('Une erreur technique est survenue. Veuillez réessayer.');
        return true;
    }
    return false;
}

async function addProductToCart(product, quantity) {
    // IMPORTANT : un script/app de la boutique patche window.fetch et réécrit le
    // corps des requêtes /cart/add.js (il ajoute le produit de la page courante
    // au lieu de l'id demandé). On passe donc par XMLHttpRequest, qui n'est pas
    // intercepté, pour garantir que c'est bien la variante demandée qui est ajoutée.
    return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(true);
            } else {
                console.error('addProductToCart: /cart/add.js a échoué', { id: Number(product), status: xhr.status, detail: (xhr.responseText || '').slice(0, 200) });
                resolve(false);
            }
        };
        xhr.onerror = function () {
            console.error('addProductToCart: erreur réseau /cart/add.js', { id: Number(product) });
            resolve(false);
        };
        xhr.send(JSON.stringify({ id: Number(product), quantity: quantity || 1 }));
    });
}

async function clearCart() {
    const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'}
        });
}

function displayMessage(message, containerId) {
    let messageContainer = document.getElementById(containerId);
  
    if (typeof message === "object") {
        messageContainer.textContent = Object.values(message).join("<br>");
    } else {
        messageContainer.textContent = message;
    }
}

async function fetchCartJS(){
    const response = await fetch('/cart.js')
    const data = await response.json();
    return data.items;
}

async function getCustomerIp(){
    // Délègue à fbGetClientIp (theme.liquid) : délai max, cache de session, ne lève jamais d'erreur
    if (typeof window.fbGetClientIp === 'function') return window.fbGetClientIp(4000);
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (e) {
        return null;
    }
}

async function getProductMetaData(productId){
    const response = await fetch(`/cart?view=meta-data.json`);
    const data = await response.json();
    return data;
}

function generateHash(data, secretKey) {
    const hash = CryptoJS.SHA256(data + secretKey);
    return hash.toString(CryptoJS.enc.Hex);
}

function shouldApplyDiscount(cartItems){
    const subscriptionDiscount = getSessionStorage('subscription_discount');
    let hasDiscount = false;
    if(subscriptionDiscount) {
        hasDiscount = subscriptionDiscount === 'true';
    }

    const subscriptionActive = getSessionStorage('subscription_active');
    let hasSubscriptionActive = false;
    if(subscriptionActive) {
        hasSubscriptionActive = subscriptionActive === '1';
    }
    
    let hasSubscriptionInCart = false;
    cartItems.forEach(item => {
        if (item.shopify_variant_id == 57062266372256 || item.is_subscription || item.variant_id == 57062266372256) {
            hasSubscriptionInCart = true;
        }
    });
    
    const shouldApplyDiscount = hasDiscount || hasSubscriptionInCart || hasSubscriptionActive;
    return shouldApplyDiscount;
}

function hideLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = false;
        button.style.opacity = '1';
        loader.style.display = 'none';
    }
}

function showLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = true;
        button.style.opacity = '0.3';
        loader.style.display = 'block';
    }
}

function setSessionStorage(name, value, maxAge) {
    const data = {
      value: value,
      timestamp: Date.now(),
      maxAge: maxAge * 1000 // Convertir en millisecondes
    };
    sessionStorage.setItem(name, JSON.stringify(data));
}

function getSessionStorage(name) {
    try {
      const item = sessionStorage.getItem(name);
      if (!item) return null;
      
      const data = JSON.parse(item);
      const now = Date.now();
      
      // Vérifier si l'élément a expiré
      if (data.maxAge && (now - data.timestamp) > data.maxAge) {
        sessionStorage.removeItem(name);
        return null;
      }
      
      return data.value;
    } catch (e) {
      console.warn('Erreur lors de la lecture du sessionStorage:', e);
      return null;
    }
}

async function getAccountCustomerData(email, orderId){
    try {
        const apiKeyData = generateTemporalApiKey();
        const payload = {
            email: email.trim(),
            orderId: orderId.trim(),
            apiKey: apiKeyData.apiKey,
            footprint: apiKeyData.footprint,
            timestamp: Date.now()
        };

        const apiConfig = getApiConfig();
        const response = await fetch(apiConfig.url_account, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const text = await response.text();

        if (handleUnauthorizedAccess(text)) {
            window.location.reload();
            return;
        }

        const sessionData = JSON.parse(text);
        
        if (sessionData && !sessionData.error) {
            const dataForSession = {
                data: sessionData,
                email: email,
                orderId: orderId,
                _ts: Date.now()
            };
            setSessionStorage('accountCustomerData', JSON.stringify(dataForSession), 3600);
            return dataForSession;
        }

        return sessionData;
        
    } catch (err) {
        console.error('Erreur getAccountCustomerData:', err);
        return { error: 'Erreur de connexion au serveur' };
    }
}

// ==========================================================================
// Tracking Facebook AddToCart (sendFacebookEvent / getFbp / getFbc définis dans theme.liquid)
// ==========================================================================

// Paramètres de tracking transmis au checkout externe (via load.redirect.lezarta.com)
function getCheckoutTrackingParams() {
    let params = '';
    try {
        if (typeof window.getFbp === 'function') {
            params += '&fbp=' + encodeURIComponent(window.getFbp());
            const fbc = window.getFbc();
            if (fbc) params += '&fbc=' + encodeURIComponent(fbc);
        }
    } catch (e) {
        console.warn('[FB Tracking] Paramètres de tracking checkout indisponibles', e);
    }
    return params;
}

// Quantités demandées par variante dans la requête /cart/add
// (la réponse Shopify renvoie la quantité totale de la ligne, pas la quantité ajoutée)
function getRequestedQuantities(body) {
    const quantities = {};
    try {
        let entries = [];
        if (body instanceof FormData || body instanceof URLSearchParams) {
            entries = Array.from(body.entries());
        } else if (typeof body === 'string') {
            const json = JSON.parse(body);
            const items = Array.isArray(json.items) ? json.items : [json];
            items.forEach(item => {
                if (item && item.id) quantities[item.id] = parseInt(item.quantity, 10) || 1;
            });
            return quantities;
        }

        const singleId = entries.find(([key]) => key === 'id');
        if (singleId) {
            const quantity = entries.find(([key]) => key === 'quantity');
            quantities[singleId[1]] = parseInt(quantity && quantity[1], 10) || 1;
        }
        // Format items[0][id] / items[0][quantity]
        const itemIds = {};
        const itemQuantities = {};
        entries.forEach(([key, value]) => {
            const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
            if (match) (match[2] === 'id' ? itemIds : itemQuantities)[match[1]] = value;
        });
        Object.keys(itemIds).forEach(index => {
            quantities[itemIds[index]] = parseInt(itemQuantities[index], 10) || 1;
        });
    } catch (e) {}
    return quantities;
}

// AddToCart : envoyé une fois l'ajout confirmé par Shopify, avec les produits réellement ajoutés
async function trackAddToCart(addedItems, requestedQuantities = {}) {
    if (typeof window.sendFacebookEvent !== 'function') return;
    const subscriptionVariantId = 57062266372256;
    const items = addedItems.filter(item => item && item.variant_id && item.variant_id != subscriptionVariantId);
    if (items.length === 0) return;

    // Identifiants produits (metafield productId) utilisés pour Meta
    const metaByVariant = {};
    try {
        const productMetaData = await getProductMetaData();
        (productMetaData.meta_product_id_array || []).forEach(meta => {
            metaByVariant[meta.variant_id] = meta;
        });
    } catch (e) {
        console.warn('[FB Tracking] meta-data du panier indisponible', e);
    }

    const productIDs = [];
    const contentNames = [];
    const contentCategories = [];
    let totalPrice = 0;
    let numItems = 0;

    items.forEach(item => {
        const meta = metaByVariant[item.variant_id];
        if (meta && meta.id) {
            productIDs.push(String(meta.id).split('.')[0]);
        }
        const quantity = requestedQuantities[item.variant_id] || requestedQuantities[item.id] || item.quantity || 1;
        const unitPrice = (item.final_price != null ? item.final_price : item.price) || 0;
        contentNames.push(item.product_title || '');
        if (item.product_type) contentCategories.push(item.product_type);
        totalPrice += (unitPrice * quantity) / 100;
        numItems += quantity;
    });

    const customData = {
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        value: parseFloat(totalPrice.toFixed(2)),
        content_ids: productIDs,
        content_type: "product",
        content_name: contentNames.join(', '),
        num_items: numItems
    };
    if (contentCategories.length > 0) customData.content_category = contentCategories.join(', ');

    window.sendFacebookEvent("AddToCart", customData);
}

// Intercepte tous les ajouts au panier (bouton principal, sticky bar, quick-add, bundles…)
(function installAddToCartTracking() {
    if (window.__fsAddToCartTrackingInstalled) return;
    window.__fsAddToCartTrackingInstalled = true;

    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
        const request = originalFetch.apply(this, arguments);
        try {
            const url = typeof input === 'string' ? input : (input && input.url) || String(input);
            const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
            const headers = (init && init.headers) || {};
            const noTrack = headers instanceof Headers ? headers.has('X-FS-No-Track') : !!headers['X-FS-No-Track'];

            if (method === 'POST' && !noTrack && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
                const requestedQuantities = getRequestedQuantities(init && init.body);
                request.then(response => {
                    if (!response.ok) return;
                    response.clone().json()
                        .then(data => trackAddToCart(Array.isArray(data.items) ? data.items : [data], requestedQuantities))
                        .catch(error => console.warn('[FB Tracking] AddToCart non envoyé', error));
                }).catch(() => {});
            }
        } catch (e) {
            console.warn('[FB Tracking] Erreur interception ajout panier', e);
        }
        return request;
    };
})();
